import * as XLSX from "xlsx";

export const XLSX_down_ = (data: any, type: string) => {
  if (type === "") {
    return;
  }
  const getTransformedData = () => {
    return data.flatMap((item: any) =>
      item.order_details.map((detail: any) => {
        const baseData = {
          주문자: item.order_name,
          닉네임: item.order_nickname,
          주문일시: detail.detail_order_dt,
          상품번호: detail.product_seq,
          품목명: detail.product_name,
          옵션: detail.option_name,
          단가: detail.product_price,
          수량: detail.order_cnt,
          총금액: detail.order_price,
        };

        if (
          type === "미입금" ||
          type === "입금확인" ||
          type === "배송준비" ||
          type === "배송완료"
        ) {
          return {
            ...baseData,
            택배비: item.delivery_price,
            총결제금액: item.total_payment,
            받으시는분: item.addr_phone,
            받는분담당자: "",
            받는분핸드폰: "",
            받는분우편번호: item.addr_num,
            받는분총주소: `${item.addr_basic} ${item.addr_detail}`,
            운임Type: "B",
            지불조건: "",
            출고번호: "",
            특기사항: "",
            메모1: detail.order_detail_seq,
            메모2: "",
            메모3: "",
            메모4: "",
            운송장번호: detail.delivery_info,
          };
        } else if (type === "주문취소") {
          return {
            ...baseData,
            취소일시: detail.status_update_dt,
          };
        } else if (type === "환불처리") {
          return {
            ...baseData,
            취소일시: detail.status_update_dt,
            메모1: detail.refund_memo,
          };
        }
        return baseData;
      })
    );
  };

  const excelHandler = {
    getExcelFileName: () => {
      const fileNames: Record<string, string> = {
        미입금: "쇼핑메이트_미입금.xlsx",
        입금확인: "쇼핑메이트_주문내역.xlsx",
        배송준비: "쇼핑메이트_주문내역.xlsx",
        배송완료: "쇼핑메이트_주문내역.xlsx",
        주문취소: "쇼핑메이트_주문취소내역.xlsx",
        환불처리: "쇼핑메이트_환불처리내역.xlsx",
      };
      return fileNames[type] || "쇼핑메이트_엑셀파일.xlsx";
    },
    getSheetName: () => "주문내역",
    getExcelData: getTransformedData,
    getWorksheet: () => XLSX.utils.json_to_sheet(getTransformedData()),
  };

  const datas = excelHandler.getWorksheet();
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, datas, excelHandler.getSheetName());
  XLSX.writeFile(workbook, excelHandler.getExcelFileName());
};
